@if (data) {
  <div>
    @for(arm of data.all_arms; track arm) {
      <div class="mb-4">
        <ul class="list-disc text-black pl-5">
          <li>
            <h3 class="text-lg font-semibold text-gray-900 mb-1">Arm Name: {{ arm.name }}</h3>
            <div class="px-4">
              <p class="text-gray-800"><strong>Arm Short Name :</strong> {{ arm.short_name }}</p>
              <p class="text-gray-800"><strong>Arm Code :</strong> {{ arm.code }}</p>
              <p class="text-gray-800"><strong>Arm Description :</strong> {{ arm.description }}</p>
              <p class="text-gray-800"><strong>Randomization Group :</strong> {{ arm.randomization_group }}</p>
            </div>
          </li>
        </ul>
      </div>
    }
  </div>
}
